import { Button } from '@agently/ui';
import { getMobileOS } from '@agently/utils';
import { useMount } from 'ahooks';
import { useMemo, useRef } from 'react';

import logo from './logo.png';

const getIOSVersion = () => {
  const ua = navigator.userAgent;
  // Parse iOS version to show accurate installation steps.
  const match = ua.match(/OS (\d+)(?:[._](\d+))?/i);
  if (!match) {
    return null;
  }
  return {
    major: Number(match[1]),
    minor: Number(match[2] || 0),
  };
};

const getIOSInstructions = () => {
  const version = getIOSVersion();
  if (version && version.major >= 17) {
    return [
      'Open this page in Safari.',
      'Tap the "..." (three dots) button located in the menu bar.',
      'Tap the Share (square with an up arrow) from the list.',
      'Scroll down the list of options and select "Add to Home Screen".',
      'Tap "Add" in the top right corner to finish.',
    ];
  }
  return [
    'Open this page in Safari.',
    'Look at the navigation bar at the bottom and tap the Share icon (square with an up arrow) located in the center.',
    'Scroll down the list of options and select "Add to Home Screen".',
    'Tap "Add" in the top right corner to finish.',
  ];
};

const Landing = () => {
  const deferredPrompt = useRef<any>(null);
  const mobileOS = useMemo(() => getMobileOS(), []);
  const isAndroid = mobileOS === 'Android';
  const isIOS = mobileOS === 'iOS';
  const iosInstructions = useMemo(
    () => (isIOS ? getIOSInstructions() : []),
    [isIOS],
  );

  useMount(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt.current = e;
    });
  });

  const handleClick = async () => {
    if (!deferredPrompt.current) {
      return;
    }
    deferredPrompt?.current?.prompt();
    await deferredPrompt?.current?.userChoice;
    deferredPrompt.current = null;
  };
  return (
    <div className="p-3 bg-white flex-1">
      <div className="flex items-center justify-center mb-5">
        <img alt="" height="67" src={logo} srcSet={`${logo} 2x`} width="150" />
      </div>
      <div className="bg-gray-100 rounded-xl border border-gray-200 p-6 flex flex-col gap-2 mb-4">
        <p>Welcome!</p>
        <p>
          <strong>
            Agently is the platform we use to provide agents with daily coaching
            and tools that will help you get more clients and close more
            transactions.
          </strong>
        </p>
        <p>
          Important: It is your responsibility to regularly submit
          accountability and production reports. It only takes a few seconds,
          but helps you stay on track to achieve your GCI goal.
        </p>
      </div>
      {isAndroid ? (
        <Button className="w-full mb-4" onClick={handleClick}>
          Install the app
        </Button>
      ) : null}
      {isIOS ? (
        <div className="bg-gray-100 rounded-xl border border-gray-200 p-4 mt-5 text-sm text-left mb-4">
          <p className="font-semibold mb-3">
            To install this app on your iPhone:
          </p>
          <ol className="list-decimal pl-5 space-y-2">
            {iosInstructions.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      ) : null}
    </div>
  );
};

export default Landing;
